module.exports = __webpack_public_path__ + "static/media/neckband-template-big.1f7c55ea.jpg";